import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { IPropertyDetails } from '../../shared/models/propertydetails';
import { ValidationService } from '../../shared/providers/validation.service';
import { SharePropertyEmailInputModel } from '../../shared/models/SharePropertyEmailInputModel';
import { SharePropertyLinkedInInputModel } from '../../shared/models/SharePropertyLinkedInInputModel';
import { MultipleEmailIdModel } from '../../shared/models/MultipleEmailIdModel';
import { ToastService } from '../../shared/providers/toast.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-share-property',
  templateUrl: './Share-Property.component.html'
})

export class SharePropertycomponent implements OnInit {
  @Input() property: IPropertyDetails;
  @Input() modalRef: BsModalRef;
  haveaccesstoviewlocation: boolean = true;
  sharePropertyEmailInputModel = {} as SharePropertyEmailInputModel;
  sharePropertyLinkedInInputModel = {} as SharePropertyLinkedInInputModel;
  user: any;
  emailValid: boolean = true;
  emailvalidation: string = '';
  mailIds: MultipleEmailIdModel[];
  keyCode: number[];
  disableButton: boolean = true;
  isZCF: boolean = false;

  constructor(private _propertyService: PropertyListingService, private authService: AuthenticationService, private _toastService: ToastService,
    private _validationService: ValidationService) { }
  ngOnInit() {
    this.user = this.authService.user != null ? this.authService.user : '';
    this.mailIds = [];
    this.keyCode = [32, 188, 13];
  }
  ShareProperty() {
    if (this.mailIds.length == 0) {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please enter any mail id", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      return false;
    }
    else if (this.disableButton == true) {
      if (this.property.PropertyCharacteristicsList.filter(x => x.Id == 2908).length > 0) {
        this.isZCF = true;
      }
      if (this.property.ConfidentialLocation && !this.property.IsPortfolio) {
        this.haveaccesstoviewlocation = false;
      }
      else {
        this.haveaccesstoviewlocation = true;
      }
      this.sharePropertyEmailInputModel.SendMailId = this.mailIds.map(function (data) { return data.value }).join(',');
      this.sharePropertyEmailInputModel.PropertyName = this.property.Tenant;
      this.sharePropertyEmailInputModel.Image = this.property.Images.length != 0 ? this.property.Images.find(data => data.IsDefault == true).FilePath : '';
      this.sharePropertyEmailInputModel.CreditRating = this.property.Rating;
      this.sharePropertyEmailInputModel.CapRate = this.isZCF ? 'ZCF' : String(this.property.CapRate);
      this.sharePropertyEmailInputModel.City = this.haveaccesstoviewlocation?this.property.City:'Confidential';
      this.sharePropertyEmailInputModel.State = this.haveaccesstoviewlocation ? this.property.State : 'Confidential' ;
      this.sharePropertyEmailInputModel.FromMailId = this.user.UserName;
      this.sharePropertyEmailInputModel.Subject = this.property.PropertyName;
      this.sharePropertyEmailInputModel.AskingPrice = this.property.Price.toLocaleString('en');
      this.sharePropertyEmailInputModel.PropertyId = this.property.Id;
      this.sharePropertyEmailInputModel.RemainingTerm = this._validationService.toYearMonthConverter(this.property.RemainingTerm, false);
      this.disableButton = false;
      this._propertyService.shareProperty(this.sharePropertyEmailInputModel).subscribe(responds => {
        let x = responds;
        if (x === 1) {
          this._toastService.addToast({ title: 'Success', msg: 'Shared Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else if (x === 0) {
          this._toastService.addToast({ title: 'Failure', msg: 'Sharing failed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }

        this.modalRef.hide();
      });
    }
  }
  validEmail$(control: any) {

    if (control.value != "") {
      let serchfind: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(control.value);
      if (serchfind == false) {
        return {
          'validEmail$': true
        };
      }
    }

    return null;
  }

  public validators = [this.validEmail$];

  public errorMessages = {
    'validEmail$': 'Invalid Email Address'
  };
}
